import Vue from 'vue'

// import only what you use
// full list of components here: https://element.eleme.io/2.13/#/en-US/component/quickstart

import {
  Container,
  Row,
  Col,
  Header,
  Main,
  Aside,
  Footer,
  Card,
  Table,
  TableColumn,
  Pagination,
  Button,
  Tooltip,
  Tag,
  Form,
  FormItem,
  Image,
  Avatar,
  Autocomplete,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Select,
  Option,
  DatePicker,
  TimeSelect,
  TimePicker,
  Dialog,
  Tabs,
  TabPane,
  Steps,
  Step,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Upload,
  Progress,
  Alert,
  MessageBox,
  Message,
  Loading,
  Divider,
  Popconfirm,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Popover,
  Badge,
  Rate
} from 'element-ui'
import { ElementTiptapPlugin } from 'element-tiptap'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-tiptap/lib/index.css'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
//import optionGroup from "element-ui/packages/option-group";

//Vue.component(optionGroup.name, optionGroup)

locale.use(lang)

Vue.use(Container)
Vue.use(Row)
Vue.use(Col)
Vue.use(Header)
Vue.use(Main)
Vue.use(Aside)
Vue.use(Footer)
Vue.use(Card)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Tag)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Autocomplete)
Vue.use(InputNumber)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(TimeSelect)
Vue.use(TimePicker)
Vue.use(Dialog)
Vue.use(Upload)
Vue.use(Progress)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Alert)
Vue.use(Divider)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(Badge)
Vue.use(Image)
Vue.use(Avatar)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Rate)

Vue.use(ElementTiptapPlugin, {
  /* plugin options */
})

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
//Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

export default () => {
  Vue.use(Element, {
    locale
  })
}
